import * as yup from 'yup'

import { transformUrl } from './url'

export function videoUrl(maxLength = 200) {
  return new VideoUrlSchema(maxLength)
}

export class VideoUrlSchema extends yup.StringSchema {
  constructor(maxLength: number) {
    super()

    // HACK: schema.type is supposed to be read-only, but who cares, right ?
    //@ts-ignore
    this.type = 'videoUrl'

    this.withMutation((schema) => {
      this.transform(function (value) {
        return transformUrl(value, true)
      })
      return schema.url().max(maxLength)
    })
  }
}
